import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

require.ensure([], () => {  
    require('./WeekSheetApproval.less');
});

import TaskView from './TaskView';
import WeekView from './WeekView';

class UserItem extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            showProjectView: false,
            showWeekView: false
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleClick = () => {
        this.props.handleClick(this.props.id);
    }

    handleProjectViewClick = () => {
        this.setState({
            showProjectView: !this.state.showProjectView
        });
    }

    handleWeekViewClick = () => {
        this.setState({
            showWeekView: !this.state.showWeekView
        });
    }

    // RENDER METHOD

    render = () => {
        let hoursApproved = this.props.user.timesheet.hoursApproved;
        let hoursEntry = this.props.user.timesheet.hoursEntry;
        let hoursSubmitted = this.props.user.timesheet.hoursSubmitted;

        if (this.props.active) {
            return (
                <div className="panel panel-default panel-pmproject" >
                        <div className="panel-heading" role="tab" id="headingThree-outer">
                            <h4 className="panel-title" style={{backgroundColor : "#888"}}>
                            <a style={{"cursor" : "pointer"}} onClick={this.handleClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                                {this.props.user.givenName + " " + this.props.user.surname}
                                <span className="acc"><span className="md-expand-more"></span></span>
                                <span style={{textTransform : "none"}} className="pull-right">
                                    <span style={{fontStyle : "italic"}}> { hoursEntry } </span>
                                    <span> { hoursSubmitted && hoursEntry ? "|" : ""} {hoursSubmitted} </span>
                                    <span>
                                        { hoursApproved && (hoursEntry || hoursSubmitted) ? "|" : ""} {hoursApproved} &nbsp;
                                        { hoursApproved ? <span className="md-done" /> : null }
                                    </span>
                                </span>
                            </a>
                            </h4>
                        </div>
                        <div id="collapseThree-outer" className="panel-collapse" role="tabpanel" aria-labelledby="headingThree">
                            <div className="panel-body">
                                <div className="panel-group" id="accordion-inner" role="tablist" aria-multiselectable="true">
                                    <TaskView
                                        active={this.state.showProjectView}
                                        approvedHours={this.props.user.approvedHours}
                                        handleClick={this.handleProjectViewClick}
                                        status={this.props.user.timesheet.status}
                                        />
                                    <WeekView
                                        active={this.state.showWeekView}
                                        date={this.props.date}
                                        handleClick={this.handleWeekViewClick}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
            );

        } else {
            return (
                <div className="panel panel-default panel-pmproject" >
                        <div className="panel-heading" role="tab" id="headingThree-outer">
                            <h4 className="panel-title" style={{backgroundColor : "#888"}}>
                            <a style={this.props.user.timesheet ? {"cursor" : "pointer"} : {}} onClick={this.handleClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                                {this.props.user.givenName + " " + this.props.user.surname}
                                { this.props.user.timesheet ? <span className="acc"><span className="md-chevron-right"></span></span> : null}
                                <span style={{textTransform : "none"}} className="pull-right">
                                    <span style={{fontStyle : "italic"}}> { hoursEntry } </span>
                                    <span> { hoursSubmitted && hoursEntry ? "|" : ""} {hoursSubmitted} </span>
                                    <span>
                                        { hoursApproved && (hoursEntry || hoursSubmitted) ? "|" : ""} {hoursApproved} &nbsp;
                                        { hoursApproved ? <span className="md-done" /> : null }
                                    </span>
                                </span>
                            </a>
                            </h4>
                        </div>
                        <div id="collapseThree-outer" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                            <div className="panel-body">
                            </div>
                        </div>
                    </div>
            );
        }
    }
}

UserItem.propTypes = {
    active: PropTypes.bool,
    date: PropTypes.object,
    handleClick: PropTypes.func,
    id: PropTypes.number,
    user: PropTypes.object
};

export default connect()(UserItem);



/** WEBPACK FOOTER **
 ** ./src/app/components/UserItem.js
 **/